import React from 'react';

// Docked mini-player, at the API's 200x200 minimum. YouTube's API terms
// forbid blocking or obscuring the embedded player's own branding/
// attribution while it's actually playing, so it can't stay display:none the
// way a hidden SoundCloud widget can (SoundCloud's required credit is
// rendered separately, outside the iframe). Position/visibility styles live
// on this OUTER wrapper, not the ref'd div passed in - YT.Player replaces
// its target element with a bare <iframe> rather than rendering inside it,
// so any style on the target itself is discarded along with the div the
// moment the player mounts.
//
// Two layout modes:
// - floating (default): fixed to the viewport corner. Only safe on
//   ancestors with no filter/backdrop-filter/transform of their own - any of
//   those establish a containing block for `position: fixed` descendants,
//   which silently re-anchors this to the ancestor's own (much smaller) box
//   instead of the viewport, clipping it into a near-opaque block over
//   whatever content is already there instead of floating clear of it.
// - inline (`inline` prop): flows in normal layout, expanding its container
//   to make room instead of overlaying it. Use this on any row/card that has
//   its own blur/backdrop-filter background.
// `bottom` lifts the floating player clear of a bar fixed along the bottom
// (a number of px or any CSS length). `onClose` adds a close button beside
// it - outside the player, so it never covers YouTube's own controls.
function YoutubeMiniPlayer({ containerRef, active, inline = false, bottom = 16, onClose }) {
  const style = inline
    ? (active
        ? { width: 200, height: 200, margin: '10px auto 0', borderRadius: 10, overflow: 'hidden' }
        : { position: 'absolute', width: 1, height: 1, overflow: 'hidden', opacity: 0, pointerEvents: 'none' })
    : (active
        ? {
            position: 'fixed', bottom, right: 16, width: 200, height: 200,
            // With a close button beside it, the corner radius goes on the
            // iframe (listenPlayer.css) so the button isn't clipped.
            borderRadius: 10, overflow: onClose ? 'visible' : 'hidden', boxShadow: '0 4px 16px rgba(0,0,0,0.5)',
            zIndex: 1000,
          }
        : { position: 'fixed', bottom, right: 16, width: 200, height: 200, opacity: 0, pointerEvents: 'none' });

  return (
    <div style={style} className={onClose && !inline ? 'yt-mini-float' : undefined}>
      <div ref={containerRef} />
      {onClose && active && !inline && (
        <button type="button" className="yt-mini-close" onClick={onClose} aria-label="Close video">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" /></svg>
        </button>
      )}
    </div>
  );
}

export default YoutubeMiniPlayer;
